(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    // A manual-confirmation tool must reveal its submit button to the user.
  const cartModelContext = document.modelContext || navigator.modelContext;
  if (cartModelContext && typeof cartModelContext.addEventListener === 'function') {
    const revealCartTool = (event) => {
      if (event.toolName !== 'nordsign_review_cart_checkout') return;
      const notification = document.querySelector('cart-notification');
      if (notification && typeof notification.open === 'function' && !notification.notification.classList.contains('active')) {
        notification.setActiveElement(document.activeElement);
        notification.open();
      }
    };
    // Current Chrome emits this on window; the draft specification uses ModelContext.
    window.addEventListener('toolactivated', revealCartTool);
    cartModelContext.addEventListener('toolactivated', revealCartTool);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordsign-product-preview"] && !Shopify.designMode) return;
  try {
    class ProductPreview extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const media = this.querySelector('.ns-product-preview');
      const images = [...this.querySelectorAll('[data-preview-image]')];
      const dots = this.querySelector('.ns-product-preview__dots');
      if (!media || !dots || !images.length) return;
      const buttons = [...dots.querySelectorAll('button')];
      const arrows = [...this.querySelectorAll('[data-preview-step]')];
      const cardGallery = this.hasAttribute('data-card-gallery');
      const hoverPointer = matchMedia('(hover: hover) and (pointer: fine)');
      let previewing = false;
      let touchStart = null;
      let suppressClickUntil = 0;
      const available = () => images.flatMap((image, index) => image.complete && image.naturalWidth > 0 ? [index] : []);
      const render = () => {
        const indices = available();
        const requested = this.manualSelection ? this.selectedIndex : previewing ? indices.find(index => index > 0) : 0;
        const current = indices.includes(requested) ? requested : indices[0] ?? 0;
        this.currentIndex = current;
        this.classList.toggle('is-ready', indices.length > 1);
        this.classList.toggle('is-setting', current > 0);
        images.forEach((image, index) => {
          image.classList.toggle('is-active', index === current);
          image.setAttribute('aria-hidden', String(index !== current));
        });
        dots.hidden = indices.length < 2;
        arrows.forEach(button => { button.hidden = indices.length < 2; });
        buttons.forEach((button, index) => {
          button.hidden = !indices.includes(index);
          button.setAttribute('aria-pressed', String(index === current));
          if (!button.hidden) button.setAttribute('aria-label', `${dots.getAttribute('aria-label')}: ${indices.indexOf(index) + 1} / ${indices.length}`);
        });
      };
      const select = index => {
        this.manualSelection = true;
        this.selectedIndex = index;
        render();
      };
      const step = direction => {
        const indices = available();
        if (indices.length < 2) return;
        const position = indices.indexOf(this.currentIndex);
        select(indices[(position + direction + indices.length) % indices.length]);
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index), { signal });
        button.addEventListener('pointerenter', event => {
          if (cardGallery && event.pointerType === 'mouse' && hoverPointer.matches) select(index);
        }, { signal });
      });
      arrows.forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        step(Number(button.dataset.previewStep));
      }, { signal }));
      dots.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const indices = available();
        if (!indices.length) return;
        event.preventDefault();
        if (event.key === 'Home') select(indices[0]);
        else if (event.key === 'End') select(indices[indices.length - 1]);
        else step(event.key === 'ArrowRight' ? 1 : -1);
        buttons[this.currentIndex].focus();
      }, { signal });
      images.forEach(image => {
        image.addEventListener('load', render, { signal });
        image.addEventListener('error', render, { signal });
      });
      media.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') touchStart = {id: event.pointerId, x: event.clientX, y: event.clientY};
      }, { signal, passive: true });
      media.addEventListener('pointerup', event => {
        if (!touchStart || touchStart.id !== event.pointerId) return;
        const dx = event.clientX - touchStart.x;
        const dy = event.clientY - touchStart.y;
        touchStart = null;
        if (available().length < 2 || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
        suppressClickUntil = performance.now() + 700;
      }, { signal, passive: true });
      media.addEventListener('pointercancel', () => { touchStart = null; }, { signal });
      media.addEventListener('click', event => {
        if (event.detail > 0 && performance.now() < suppressClickUntil) event.preventDefault();
      }, { signal });
      const mobile = matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)');
      this.addEventListener('pointerenter', () => { if (!mobile.matches) { previewing = true; render(); } }, { signal });
      this.addEventListener('pointerleave', () => { if (!mobile.matches) { previewing = false; render(); } }, { signal });
      const resetPreview = () => {
        previewing = false;
        render();
      };
      mobile.addEventListener('change', resetPreview, { signal });
      window.addEventListener('resize', resetPreview, { signal });
      resetPreview();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  if (!customElements.get('nordsign-product-preview')) customElements.define('nordsign-product-preview', ProductPreview);
  } catch(e) { console.error(e); }
})();

})();
